import React from 'react';
import { getServiceRecordStatusColor } from '../constants/serviceRecordStatusColors';
import './ServisDurumFilterPills.css';

/**
 * Açık servis kayıtları — çoklu durum pill filtresi
 */
const ServisDurumFilterPills = ({
  kalemler = [],
  selectedDurumlar = [],
  onToggle,
  loading = false,
}) => {
  if (!kalemler.length && !loading) {
    return null;
  }

  return (
    <div className="servis-durum-pills" role="group" aria-label="Servis durumu filtresi">
      {loading && kalemler.length === 0 ? (
        <span className="servis-durum-pills__loading">
          <i className="fas fa-spinner fa-spin" aria-hidden="true" />
        </span>
      ) : null}
      {kalemler.map(({ durum, adet }) => {
        const color = getServiceRecordStatusColor(durum);
        const active = selectedDurumlar.includes(durum);
        return (
          <button
            key={durum}
            type="button"
            className={`servis-durum-pills__pill${active ? ' servis-durum-pills__pill--active' : ''}`}
            style={{
              '--pill-color': color,
              ...(active
                ? { background: color, borderColor: color, color: '#fff' }
                : { background: '#fff', borderColor: color, color }),
            }}
            aria-pressed={active}
            disabled={loading}
            onClick={() => onToggle(durum)}
          >
            <span>{durum}</span>
            {adet != null ? (
              <span className="servis-durum-pills__count">{adet}</span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
};

export default ServisDurumFilterPills;
